function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { track } from '@adsk/acs-web-analytics';
import { loadScripts } from '@adsk/alloy-helpers';
import { useUser } from '@adsk/alloy-provider';
import { SimpleModal } from '@adsk/alloy-react-modal';
import theme, { getInteractiveStyles } from '@adsk/alloy-react-theme';

// eslint-disable-next-line spellcheck/spell-checker
const MARKETING_SURVEY_GUIDE_ID = 'alyTR0tUIBfa76oinWvJ5Aq2dgM';
const SCRIPT_KEY = 'MARKETO_NEW_USER_SURVEY';
const SCRIPT = {
  src: '//constructioncloud.autodesk.com/js/forms2/js/forms2.min.js'
};
const ANALYTICS = {
  VIEW: 'onboarding.marketing_form.view',
  SUBMIT: 'onboarding.marketing_form.submit'
};
const StyledForm = styled.form.withConfig({
  displayName: "MarketingSurveyModal__StyledForm",
  componentId: "sc-vwx11u-0"
})({
  margin: '0 auto',
  maxWidth: 300,
  width: '100% !important',
  '.mktoFormRow h2': _objectSpread(_objectSpread({}, theme.typography.heading2), {}, {
    marginBottom: 16,
    textAlign: 'center'
  }),
  '.mktoHtmlText': {
    width: '100% !important'
  },
  '.mktoLabel': _objectSpread(_objectSpread({}, theme.typography.labelMedium), {}, {
    marginTop: 10,
    width: 'auto !important'
  }),
  'div.mktoGutter, div.mktoFormCol, div.mktoFieldWrap': {
    float: 'none'
  },
  '.mktoFieldWrap input.mktoField, .mktoFieldWrap select.mktoField': _objectSpread({
    background: 'none',
    border: `1px solid ${theme.colors.charcoal400}`,
    borderRadius: 3,
    color: theme.colors.charcoal900,
    height: 36,
    left: 0,
    marginTop: 4,
    outline: 'none',
    padding: '0 12px 1px',
    // Visually center text
    width: '100%'
  }, getInteractiveStyles(false)),
  '.mktoField': {
    float: 'none',
    marginTop: 4,
    width: '100% !important'
  },
  'div.mktoError': {
    color: theme.colors.charcoal200
  },
  '.mktoError div.mktoErrorArrow': {
    background: theme.colors.charcoal200,
    border: `1px solid ${theme.colors.charcoal200}`
  },
  '.mktoError div.mktoErrorMsg': {
    background: theme.colors.charcoal200,
    border: 'none',
    boxShadow: 'none',
    color: theme.colors.black,
    padding: '8px 12px',
    textShadow: 'none'
  },
  '.mktoButtonRow': {
    marginTop: 20
  },
  '.mktoButtonWrap.mktoSimple button.mktoButton': _objectSpread(_objectSpread(_objectSpread({}, theme.typography.labelMedium), {}, {
    background: theme.colors.adskBlue500,
    border: '1px solid transparent',
    borderRadius: 2,
    color: theme.colors.white,
    height: 36,
    padding: '0 15px'
  }, getInteractiveStyles(false)), {}, {
    '&:hover, &:focus': {
      borderColor: 'transparent'
    },
    '&:active': {
      background: theme.colors.adskBlue600,
      border: `1px solid ${theme.colors.charcoal500}`
    }
  })
});

/**
 * Marketing survey for new users.
 */
const MarketingSurvey = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    setVisibility
  } = _ref;
  const {
    user
  } = useUser();
  const {
    firstName,
    lastName,
    email,
    oxygenId,
    autodeskId
  } = user;
  // Load Marketo form only once.
  useEffect(() => {
    var _window$MktoForms;
    (_window$MktoForms = window.MktoForms2) === null || _window$MktoForms === void 0 ? void 0 : _window$MktoForms.loadForm('//constructioncloud.autodesk.com', '572-JSV-775', 2354, form => {
      form.vals({
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        oxygenID: autodeskId || oxygenId
      });
      form.onSuccess(() => {
        window.pendo.updateOptions({
          visitor: {
            marketingSurveyComplete: true
          }
        });
        setVisibility(false);
        track(ANALYTICS.SUBMIT);
        return false;
      });
    });
  }, [firstName, lastName, email, oxygenId, autodeskId, setVisibility]);
  return /*#__PURE__*/React.createElement(StyledForm, {
    ref: ref,
    id: "mktoForm_2354"
  });
});
MarketingSurvey.displayName = 'MarketingSurvey';
MarketingSurvey.propTypes = {
  /* Toggle modal visibility after survey is complete */
  setVisibility: PropTypes.func.isRequired
};

/**
 * Modal that renders marketing survey.
 */
const MarketingSurveyModal = /*#__PURE__*/React.forwardRef((props, ref) => {
  const [visible, setVisibility] = useState(false);
  useEffect(() => {
    let cancel = false;
    let timeoutId;
    const checkPendoReady = () => {
      var _window$pendo;
      if ((_window$pendo = window.pendo) !== null && _window$pendo !== void 0 && _window$pendo.guides) {
        if (window.pendo.findGuideById(MARKETING_SURVEY_GUIDE_ID)) {
          loadScripts(SCRIPT_KEY, [SCRIPT], () => {
            if (!cancel) {
              setVisibility(true);
              track(ANALYTICS.VIEW);
            }
          });
        }
      } else {
        if (!cancel) {
          timeoutId = setTimeout(checkPendoReady, 500);
        }
      }
    };
    checkPendoReady();
    return () => {
      cancel = true;
      timeoutId && clearTimeout(timeoutId);
    };
  }, [setVisibility]);
  return /*#__PURE__*/React.createElement(SimpleModal, _extends({}, props, {
    ref: ref,
    show: visible,
    disableModalExit: true,
    style: {
      paddingTop: 5,
      width: 400
    }
  }), /*#__PURE__*/React.createElement(MarketingSurvey, {
    setVisibility: setVisibility
  }));
});
MarketingSurveyModal.displayName = 'MarketingSurveyModal';
export default MarketingSurveyModal;
//# sourceMappingURL=MarketingSurveyModal.js.map